/**
 * Collapsible Content — Accordion for FAQ sections
 *
 * Accordion behaviour: only one item is open at a time.
 * Uses maxHeight animation on .faq-answer for smooth expand/collapse.
 *
 * DOM expectations:
 *   .faq-item     — wrapper for each Q/A pair
 *   .faq-question — clickable header (button or div)
 *   .faq-answer   — collapsible answer body (CSS: overflow hidden, max-height 0)
 *
 * Also exposes window.toggleFaq(btn) for legacy onclick handlers.
 */
(function() {
  'use strict';

  var questions = document.querySelectorAll('.faq-question');
  if (!questions.length) return;

  /**
   * Close a single FAQ item.
   */
  function closeItem(item) {
    if (!item) return;
    item.classList.remove('open');
    item.classList.remove('active');
    var answer = item.querySelector('.faq-answer');
    if (answer) answer.style.maxHeight = null;
    var question = item.querySelector('.faq-question');
    if (question) question.setAttribute('aria-expanded', 'false');
  }

  /**
   * Open a single FAQ item.
   */
  function openItem(item) {
    if (!item) return;
    item.classList.add('open');
    item.classList.add('active');
    var answer = item.querySelector('.faq-answer');
    if (answer) answer.style.maxHeight = answer.scrollHeight + 'px';
    var question = item.querySelector('.faq-question');
    if (question) question.setAttribute('aria-expanded', 'true');
  }

  /**
   * Toggle a FAQ item. If opening, close all other open items first.
   */
  function toggle(questionEl) {
    var item = questionEl.closest('.faq-item');
    if (!item) return;

    var isOpen = item.classList.contains('open') || item.classList.contains('active');

    /* Close all other open items (accordion behaviour) */
    var openItems = document.querySelectorAll('.faq-item.open, .faq-item.active');
    openItems.forEach(function(openItem) {
      if (openItem !== item) {
        closeItem(openItem);
      }
    });

    /* Toggle the clicked item */
    if (isOpen) {
      closeItem(item);
    } else {
      openItem(item);
    }
  }

  /* ── Bind events to each question ── */

  questions.forEach(function(question) {
    /* Accessibility attributes */
    question.setAttribute('role', 'button');
    question.setAttribute('tabindex', '0');
    question.setAttribute('aria-expanded', 'false');

    /* Click handler */
    question.addEventListener('click', function(e) {
      e.preventDefault();
      toggle(this);
    });

    /* Keyboard: Enter or Space */
    question.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle(this);
      }
    });
  });

  /* ── Legacy global function for onclick="toggleFaq(this)" ── */

  window.toggleFaq = function(btn) {
    toggle(btn);
  };

})();
